import React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import { ArrowBack, Login, ShoppingCart } from '@mui/icons-material'
import { useCart } from '../../contexts/CartContext'
import { useAuth } from '../../contexts/AuthContext'

const EmptyCart: React.FC = () => {
  const { toggleCart } = useCart()
  const { isAuthenticated } = useAuth()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 6, px: 3, textAlign: 'center' }}>
      <ShoppingCart sx={{ fontSize: 80, color: 'rgba(255,255,255,0.20)', mb: 2 }} />
      <Typography variant="h6" fontWeight={900} sx={{ mb: 1 }}>
        Seu carrinho está vazio
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Adicione um pacote para continuar.
      </Typography>

      <Stack spacing={1.5} sx={{ width: '100%', maxWidth: 280 }}>
        <Button
          variant="contained"
          startIcon={<ArrowBack />}
          onClick={toggleCart}
          sx={{ borderRadius: 999, px: 3, py: 1.1, fontWeight: 900, background: 'linear-gradient(45deg, #00e676 30%, #4caf50 90%)' }}
        >
          Continuar comprando
        </Button>

        {!isAuthenticated && (
          <Button
            variant="outlined"
            startIcon={<Login />}
            onClick={() => {
              toggleCart()
              window.location.href = '/?login=1'
            }}
            sx={{ borderRadius: 999, px: 3, py: 1.1, fontWeight: 900 }}
          >
            Fazer login
          </Button>
        )}
      </Stack>
    </Box>
  )
}

export default EmptyCart

